import List from "@/components/list";

const Table = args => {

  const { listeners } = args;
  const audit = listeners["audit"] || function () { };
  const auditDetail = listeners["auditDetail"] || function () { };
  const download = listeners['download'] || function () { };

  const toUpdate = (row) => {
    audit(row);
  }

  const toDetails = (row) => {
    auditDetail(row);
  }

  const Deal = ({ props: { vo } }) => {
    const { row } = vo
    const dealConf = []

    if (row.auditStatus === 0) {
      dealConf.push(["icon-audit", "审核", () => toUpdate(row), "permissionMove:audit"])
    }

    dealConf.push(["icon-steps", "查看审核详情", () => toDetails(row), "user:audit:list"])

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Resource = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="blue_text"
        onClick={() => {
          download(item);
        }}
      >
        {item.verifyName}
      </span>
    );
  };

  const AccountColum = ({ props: { vo, type } }) => {
    const item = vo.row;
    let userName = item.moveUserName
    let userPhone = item.moveUserMobile
    if (type == 2) {
      userName = item.createUserName
      userPhone = item.createUserMobile	
    }
    return (
      <div class="user_status">
        <div>
          <div>{userName}</div>
          <div class="audit_char">{userPhone}</div>
        </div>
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "转让用户",
      prop: "userName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "转让角色",
      prop: "deptRoleName",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "被转让用户",
      prop: "oldPosition",
      minWidth: "100",
      render: vo => <AccountColum vo={vo} type={1}/>,
    },
    {
      label: "证明材料",
      // prop: "transFerDeptName",
      minWidth: "200",
      render: vo => <Resource vo={vo} />,
    },
    {
      label: "申请时间",
      prop: "createDate",
      minWidth: "120"
    },
    {
      label: "申请人",
      minWidth: "100",
      render: vo => <AccountColum vo={vo} type={2}/>,
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "80",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
